import React, { useState, useEffect } from 'react';
import { Translate } from '../../language';
import logoRecoverPassword from '../../img/logo_final_png.png';
import ViewLogin from '../../containers/ViewLogin/ViewLogin';
import { connect } from 'react-redux'
import { sendCodeToPassword, sendEmailToPassword } from '../../actions/recoverActions'

const RecoverPasswordCode = ({ history, sendCodeToPassword, isLoading, sendEmailToPassword, userEmail, loginEmail, model, errorType, location }) => {
    var email = location.state?.email
   
    const [code, setCode] = useState('')
    const [error, setError] = useState({})
    const [isValidate, setValidate] = useState(false)
    const [isEnabled, setIsEnabled] = useState(false)

    useEffect(() => {
        if(location.state?.email==null){
            history.push("/Login")
        }
    }, []);
    
    useEffect(() => {
        var code = 'code'
        if (errorType !== null && errorType.code === "ERR017") {
            setError(prevError => ({
                ...prevError,
                [code]: Translate('ERR017', 'es')
            }));
        }
        if (errorType !== null && errorType.code === "ERR015") {
            setError(prevError => ({
                ...prevError,
                [code]: Translate('ERR015', 'es')
            }));
        }
        if (errorType !== null && errorType.code === "ERR009") {
            setError(prevError => ({
                ...prevError,
                [code]: Translate('ERR009', 'es')
            }));
        }
    }, [errorType])


    const isFocused = (e) => {
        const { name } = e.target;
        setError(prevError => ({
            ...prevError,
            [name]: ''
        }));
    }

    const isEmpty = (e) => {

        const { name, placeholder, value } = e.target;
        setCode(value)
        if (value.length === 0) {
            setValidate(false)
            setError(prevError => ({
                ...prevError,
                [name]: Translate('missingField', 'es') + placeholder
            }));
        }
        else {
            setValidate(true)
            setError(prevError => ({
                ...prevError,
                [name]: ''
            }));
        }
    }

    const goToPasswordChange = (e) => {
        e.preventDefault()
        setIsEnabled(false)
        sendCodeToPassword(code, email, history)

    }

    /*  if (isLoading)
         return <div>cargando....</div>
     else */
    return (
        <ViewLogin
            type='text'
            nameInput='code'
            img={logoRecoverPassword}
            textWelcome={Translate('messageRecoverPassword', 'es')}
            inputValue={code}
            error={error.code}
            onChangeInput={isEmpty}
            onFocusInput={isFocused}
            isEnabled={isEnabled}
            setIsEnabled={setIsEnabled}
            inputPlaceholder="verificationCode"
            textButton="check"
            actionButton={goToPasswordChange}
            textDown=''
            TextlinkDown=''
            linkToDown=''
            isMenuDown={true}
            isBackgroundBlue={false}
            isActiveButton={isValidate}
            isResendCodeVerification={true}
            isRecoverPassword={true}
            textRecoverPasword={'rememberCode'}
            actionResendCode={() => {
                setIsEnabled(false)
                sendEmailToPassword(email, model, history)
            }}
        />
    )
}


const mapStateToProps = (state) => {// connect ejectua map enviandole el estado general
    return {
        userEmail: state.recover.email, // y lo que retorna map, connect lo envia a Page como Props 
        isLoading: state.recover.isLoadingViewRecoverCode,
        errorType: state.recover.errorType,
        loginEmail: state.register.loginEmail
    }
}

export default connect(mapStateToProps, { sendCodeToPassword, sendEmailToPassword })(RecoverPasswordCode)

